module.exports = __webpack_public_path__ + "img/chanpin.a9b37c3a.png";